
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refund-agreement",
      function () {
        return require("private-next-pages/refund-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refund-agreement"])
      });
    }
  